import { Stack } from "src/shared/components"
import RoleForm from "../../component/role-form"
import { RoleFormParam } from "../../roles.type"
import { useAddOrRemovePermissionsByRoleIdMutation, useCreateRoleMutation } from "src/graphql/quark/quark.type"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import ROUTE_PATHS from "src/routes/route-path"

const CreateRole = () => {
  const navigate = useNavigate()
  const [createRole, { loading: isLoadingCreateRole }] = useCreateRoleMutation()
  const [addOrRemovePermissionsByRoleId, { loading: isLoadingAddRemovePermissions }] =
    useAddOrRemovePermissionsByRoleIdMutation()

  const handleSubmit = async (val: RoleFormParam) => {
    console.log("working", val)
    // val
    const respCreateRole = await createRole({
      variables: {
        roleInputDto: {
          name: val.name,
          status: val.status
        }
      }
    })
    if (!respCreateRole?.data?.createRole?.id) {
      toast.error("Creation Failed | Something went wrong.")
      return
    }
    const respAddRemoveRolePermission = await addOrRemovePermissionsByRoleId({
      variables: {
        roleId: respCreateRole?.data?.createRole?.id,
        permissionIds: val.permissions as string[]
      }
    })
    if (respAddRemoveRolePermission.data?.addOrRemovePermissionsByRoleId) {
      toast.success(`Role ${val.name} created successfully.`)
      navigate(ROUTE_PATHS.ROLES.BASE)
      return
    }
  }
  return (
    <Stack p={2}>
      <RoleForm isSubmitting={isLoadingCreateRole || isLoadingAddRemovePermissions} onSubmit={handleSubmit} />
    </Stack>
  )
}

export default CreateRole
